import React from 'react';
import { Link } from 'react-router-dom';

const onHelpClick = e => {
  e.preventDefault();
  // console.log('clicked help email');
  HS.beacon.init();
  HS.beacon.open();
};

const AboutText = () => {
  return (
    <div className="GenericText__content">
      <h2>About Funbrain</h2>

      <p>
        Created for kids in grades Pre-K through 8, Funbrain.com has been the
        leader in free educational games for kids since 1997. Funbrain offers
        hundreds of games, books, comics, and videos that develop skills in
        math, reading, problem-solving and literacy.
      </p>

      <p>
        Educators and parents can trust our site to provide a fun and safe
        experience both at home and at school. Funbrain does not collect
        personally identifiable information from kids. For additional
        information, please see our Privacy Policy.
      </p>

      <p>
        Funbrain is published by Funbrain Holdings LLC. To learn more about
        Funbrain.com, please read our{' '}
        <Link to="/terms-of-use">terms and conditions</Link>.
      </p>

      <p>
        You can reach us at{' '}
        <a href="mailto:help@funbrain.com" onClick={onHelpClick}>
          help@funbrain.com
        </a>
        .
      </p>
    </div>
  );
};

export default AboutText;
